import { createAsyncThunk, createEntityAdapter, createSelector, createSlice } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

import { getAppointmentsSlots, filterDuplicateSlots } from 'FRONTEND/components/Calendar/utils';
import { getLocationSlots, getSlots } from 'FRONTEND/utils/backendApi/slotApi';

const slotAdapter = createEntityAdapter({
  selectId: ({ availabilityId, start }) => availabilityId + start,
  sortComparer: (a, b) => a.start > b.start ? 1 : a.start < b.start ? -1 : 0,
});


export const listLocationSlots = createAsyncThunk('slot/listLocationSlots', async({ locationId, startDate, endDate, appointmentType, canAcceptPayment }) => {
  try {
    const slots = await getLocationSlots({ locationId, startDate, endDate, appointmentType, canAcceptPayment });
    return { slots };
  } catch (error) {
    return { error: error.message };
  }
});

export const listAllExpertsSlots = createAsyncThunk('slot/listAllExpertsSlots', async({ startDate, appointmentType, status, canAcceptPayment }) => {
  try {
    const slots = await getSlots({ startDate, appointmentType, status, canAcceptPayment });
    return { slots };
  } catch (error) {
    return { error: error.message };
  }
});


const initialState = {
  ...slotAdapter.getInitialState(),
  error: null,
};

export const {
  selectById: selectSlotById,
  selectAll: selectAllSlots,
} = slotAdapter.getSelectors((state) => state.slot);

const selectDesiredDuration = (state) => state.booking.desiredDuration;

export const selectAvailableSlotsFromDuration = createSelector([selectAllSlots, selectDesiredDuration], (slots, desiredDuration) => {
  return filterDuplicateSlots(slots).reduce((acc, slot) => {
    const tmp = getAppointmentsSlots({
      acc: [],
      duration: desiredDuration,
      availabilityStart: dayjs(slot.start),
      availabilityEnd: dayjs(slot.end),
      availabilityId: slot.availabilityId,
    });
    return [...acc, ...tmp];
  }, []);
});

const slotSlice = createSlice({
  name: 'slots',
  initialState,
  reducers: {
    listRequest(state, { payload: { expertIdList, startDate, endDate, status, appointmentType } }) {},
    listSuccess(state, { payload: { slots } }) {
      slotAdapter.setAll(state, slots);
    },
    listError(state, { payload: { error } }) {
      state.error = error;
    },
    clear(state) {
      slotAdapter.setAll(state, []);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(listLocationSlots.fulfilled, (state, { payload: { slots } }) => {
      slotAdapter.setAll(state, slots);
    });
    builder.addCase(listAllExpertsSlots.fulfilled, (state, { payload: { slots } }) => {
      slotAdapter.setAll(state, slots);
    });
    builder.addCase(listAllExpertsSlots.rejected, (state, { payload: { error } }) => {
      state.error = error;
    });
  },
});

export const {
  listRequest,
  listSuccess,
  listError,
  clear,
} = slotSlice.actions;
export default slotSlice.reducer;
